export const STOP_TYPE = {
  DROPOFF: 'DROP_OFF',
};

export const SHIPMENT_STOP_TYPE = {
  DROPOFF: 'deliverShipment',
  PICKUP: 'pickupShipment',
};
